import React, { useState, FC } from "react";
import { Table, Row, Col, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { aadtionBathCoulmns as columns } from "../../helpers/sku.helper";
import { ManyToWarehouse } from "../../api/sku";
import {
  EditableRow,
  EditableCell,
} from "../../components/additionBatchEditing/additionBatchEditing.component";
import { useGlobalState } from "../../context/Provider";
import { useNavigate } from "react-router-dom";
import AdditionBatchForm from "../additionBatchSkuForm";
import AdditionBatchTypeForm from "../additionBatchTypeForm";
import NavigationMenu from "../navigationMenu/navigationMenu.component";
import GeneralConditionSkuProps from '../generalConditionSku';
import { FormattedMessage } from "react-intl";

const AdditionBatch: FC = () => {
  const [dataSource, setDataSource] = useState<any>([]);
  const [count, setCount] = useState<number>(1);
  const [visible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const { langState }: any = useGlobalState();

  const navigate = useNavigate();

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const handleDelete = (key: any) => {
    const dataSources = [...dataSource];
    setDataSource(dataSources.filter((item) => item.key !== key));
  };

  const handleAdd = (values: any) => {
    const { skuId, warehouseId, quantity, id }: any = values;
    const newData = {
      skuId: id,
      quantity,
      key: count,
      skuName: skuId,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleSubmit = (values: any) => {
    const { type, warehouseId }: any = values;
    const newDataSource = dataSource.map((item: any) => {
      return { ...item, warehouseId };
    });
    setLoading(true);
    ManyToWarehouse(type, newDataSource).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        navigate(`/panel/sku/acceptanceOfAction/group`);
      }
    });
  };

  return (
    <>
      <Row gutter={[0, 0]}>
        <Col xs={0} md={23}>
          <AdditionBatchForm handleAdd={handleAdd} />
        </Col>
        <Col xs={23} md={0}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setVisible(true)}
            className="d-flex align-items-center"
          >
            <div className="px-2">
              <FormattedMessage id="sku.search" />
            </div>
          </Button>
        </Col>
      </Row>
      <Table
        components={components}
        rowClassName={() => "editable-row"}
        dataSource={dataSource}
        columns={columns(dataSource.length, handleDelete, langState.locale)}
        scroll={{ x: 1100, y: "calc(100vh - 405px)" }}
        expandable={{
          expandedRowRender: (record: any) => {
            return (
              <>
                <GeneralConditionSkuProps info={record} />
              </>
            );
          },
        }}
      />
      <Col xs={23}>
        <AdditionBatchTypeForm
          handleSubmit={handleSubmit}
          isDisable={count > 1 ? false : true}
          loading={loading}
        />
      </Col>
      <NavigationMenu visible={visible} setVisible={setVisible}>
        <AdditionBatchForm handleAdd={handleAdd} />
      </NavigationMenu>
    </>
  );
};

export default AdditionBatch;
